import { Subscription } from "rxjs";

import { CerFormRouteOptions } from "@form/cer-form-route-options";

import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerFormContext } from "@form/cer-form-context";
import { ProviderToken } from "@angular/core";

import { CerFormView } from "./cer-form-view";

export class CerFormAdapter {
  public routeOptions?: CerFormRouteOptions;
  public context?: CerFormContext;

  protected manage(managedTearDown: Subscription) {
    this.context.subscriptionManager.add(managedTearDown);
  }

  protected inject<T>(token: ProviderToken<T>): T {
    return this.context.injector.get(token);
  }

  public async initFromRouteOptions(routeOptions: CerFormRouteOptions): Promise<boolean> {
    this.routeOptions = routeOptions;
    this.context = this.routeOptions?.context;

    return this.initPre() &&
           (await this.init()) &&
           this.initPost();
  }

  public  initPre(): boolean {
    return true;
  }

  public async init(): Promise<boolean> {
    return true;
  }

  public initPost(): boolean {
    return true;
  }

  public viewSetInit(viewSet: CerFormViewSet) {
    if (viewSet.paneViews.length == 0) {
      const view = this.view();
      if (view) {
        viewSet.viewAdd(view);
      }
    }
  }

  public view(): CerFormView {
    return null;
  }
}
